import { render, staticRenderFns } from "./FbdStyleLibrary.vue?vue&type=template&id=92485250&scoped=true"
import script from "./FbdStyleLibrary.vue?vue&type=script&lang=ts"
export * from "./FbdStyleLibrary.vue?vue&type=script&lang=ts"
import style0 from "./FbdStyleLibrary.vue?vue&type=style&index=0&id=92485250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92485250",
  null
  
)

export default component.exports